import {Component, Input, OnInit} from '@angular/core';
import {LineInputModel, View} from '../../cross-line/cross-line.component';
import {ImageState} from '../share/model';
import {fetchCommonValue} from '../share/utils';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import {initialImageTest2State} from '../../image-store/image-store.service';
import {RGBImage2} from '../share/image';
import {BoundingBox2, BoundingBox2FromCenterSize} from '../../ng3/share/boundingbox2';
import {applyColormap} from '../share/colormap';
import {SceneService} from '../../ng3/components/scene.service';
import {GroupedcrosslineService} from '../../cross-line/groupedcrossline.service';
import {map} from 'rxjs/operators';
import {Vector2, Vector3} from 'three';
import {__values} from 'tslib';
import {Slicer} from '../share/slice';

@Component({
  selector: 'app-imagecrossline',
  templateUrl: './imagecrossline.component.html',
  styleUrls: ['./imagecrossline.component.css']
})
export class ImagecrosslineComponent implements OnInit {
@Input() view: View = 'x';
  image$: Observable<RGBImage2>;
  private boxSubject = new BehaviorSubject<BoundingBox2>(
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(1, 1)),
  );
  box$ = this.boxSubject.asObservable();
  @Input()
  get box(): BoundingBox2 {
    return this.boxSubject.value;
  }
  set box(b: BoundingBox2) {
    this.boxSubject.next(b);
  }
  @Input() resize: 'image' | 'canvas' | 'fix' = 'canvas';
  private stateSubject = new BehaviorSubject<ImageState>(
    initialImageTest2State(),
  );
  state$ = this.stateSubject.asObservable();
  @Input()
  get image(): ImageState {
    return this.stateSubject.value;
  }
  set image(s: ImageState) {
    this.stateSubject.next(s);
  }
  constructor(private sceneService: SceneService,
              private groupCrossLineService: GroupedcrosslineService) {
    this.image$ = combineLatest(this.state$, this.box$, this.groupCrossLineService.crosslineMain$).pipe(
      map((x) => this.getImage(x[0], x[1], x[2])),
    );
  }

  ngOnInit() {
  }

  getImage(state: ImageState, box: BoundingBox2, cross: LineInputModel[]) {
    state = this.stateUpdate(state, box, cross);
    const imageSlice = state.filter.filter(state.slicer.slice(state.image));
    const image2 = applyColormap(imageSlice, state.colormap);
    const imageBox = this.imageBox(image2, box);
    return new RGBImage2(
      imageBox.center,
      imageBox.size,
      image2.meta.shape,
      image2.r,
      image2.g,
      image2.b,
    );
  }

  stateUpdate(state: ImageState, box: BoundingBox2, cross: LineInputModel[]): ImageState {
    switch (this.resize) {
      case 'image':
        state.slicer = new Slicer(this.view, this.indexUpdate(state.image.meta.size, state.image.meta.size.x,
           cross[cross.length - 1].position));
        break;
      case 'fix':
        state.slicer = new Slicer(this.view, this.indexUpdate(state.image.meta.size, box.size.x,
          cross[cross.length - 1].position));
        break;
      case 'canvas':
        const sceneSize = this.sceneService.size;
        state.slicer = new Slicer(this.view, this.indexUpdate(state.image.meta.size, sceneSize.size.x,
          cross[cross.length - 1].position));
        break;
    }
    return state;
  }
  indexUpdate(size: Vector3, width: number, pos: Vector3): number {
    let indexTemp = 0;
    switch (this.view) {
      case 'x':
        indexTemp = Math.floor((pos.z + width / 2) / width * size.z );
        indexTemp = Math.max(Math.min(0, indexTemp), size.z);
        break;
      case 'y':
        indexTemp = Math.floor((pos.x + width / 2) / width * size.x );
        indexTemp = Math.max(Math.min(0, indexTemp), size.x);
        break;
      case 'z':
        indexTemp = Math.floor((pos.y + width / 2) / width * size.y );
        indexTemp = Math.max(Math.min(0, indexTemp), size.y);
        break;
    }
    return indexTemp;
  }
  private imageBox(image: RGBImage2, box: BoundingBox2): BoundingBox2 {
    switch (this.resize) {
      case 'image':
        return new BoundingBox2FromCenterSize(
          image.meta.center,
          image.meta.size,
        );
      case 'fix':
        return box;
      case 'canvas':
        const sceneSize = this.sceneService.size;
        const ratio = Math.min(
          sceneSize.size.x / image.meta.size.x,
          sceneSize.size.y / image.meta.size.y,
        );
        return new BoundingBox2FromCenterSize(
          new Vector2(0, 0),
          new Vector2(image.meta.size.x * ratio, image.meta.size.y * ratio),
        );
    }
  }
}
